import React from 'react';
import { useTooltip } from '../TooltipContext';
import { TooltipPopoverProps } from '../TooltipPopover';
import * as S from './styles';

export type DefaultTooltipPopoverProps = React.PropsWithChildren<
  Pick<TooltipPopoverProps, 'style'> & {
    className?: string;
  }
>;

/**
 * A `TooltipPopover` customized for the default `Tooltip` component
 */
const DefaultTooltipPopover: React.FC<DefaultTooltipPopoverProps> = ({
  children,
  style,
}) => {
  const { arrow, arrowRef, arrowStyle } = useTooltip();

  return (
    <S.Popover style={style}>
      {children}
      {arrow && <S.Arrow ref={arrowRef} style={arrowStyle} />}
    </S.Popover>
  );
};

export default DefaultTooltipPopover;
